import { isoZ, z } from 'my-zod'

const StatusByDayDto = z.object({
  date: isoZ.instant(),
  status: z.string()
})

const ActiveAtOperatorDaysDetailDto = z.object({
  vehicleId: z.number(),
  statusByDay: StatusByDayDto.array()
})

const VehicleUseHistoryDataDto = z.object({
  checkInDateTime: isoZ.instant(),
  checkOutDateTime: isoZ.instant(),
  driverCustomerId: z.string(),
  id: z.string(),
  rentalDays: z.number(),
  vehicleId: z.number()
})

const SurveyDetail = z.object({
  /** Score that was given (1-10) on how likely the user is to recommend the experience */
  howLikelyToRecommend: z.number(),
  comment: z.string()
})
export type SurveyDetail = z.infer<typeof SurveyDetail>

const ProductLineStatsDto = z.object({
  productLine: z.string(),
  /** Waivers completed plus additional participants on those waivers completed */
  totalRiderCount: z.number(),
  /** Based on post - ride surveys completed */
  netPromoterScore: z.number(),
  /** Number of completed post ride surveys(with howLikelyToRecommend) */
  numberOfPostRideSurveys: z.number(),
  /** Number of history records with a check - out date */
  numberOfCheckOuts: z.number(),
  /** Any check - out up to a day is counted as one day, but a two day rental is two days, and so on. */
  rentalDays: z.number(),
  /** Number of days that this product line's vehicles were 'ActiveAtOperator' */
  activeAtOperatorDays: z.number(),
  /** (# of rentals days / (sum of each fleet vehicle's active-at-operator days in period)) */
  fleetUtilization: z.number(),
  /** post - ride survey details */
  surveyDetails: SurveyDetail.array(),
  activeAtOperatorDaysDetail: ActiveAtOperatorDaysDetailDto.array(),
  vehicleUseHistoryData: VehicleUseHistoryDataDto.array(),
  totalRiderCountDetails: z.object({ riderCount: z.number(), rideDate: isoZ.instant() }).array()
})
export type ProductLineStatsDto = z.infer<typeof ProductLineStatsDto>

const StatisticsDto = z.object({
  operatorId: z.number(),
  beginPeriod: isoZ.instant(),
  endPeriod: isoZ.instant(),
  productLineStats: ProductLineStatsDto.array(),
  // These are across all product lines:
  /** Waivers completed plus additional participants on those waivers completed */
  totalRiderCount: z.number(),
  /** Based on post-ride surveys completed */
  netPromoterScore: z.number(),
  /** Number of completed post ride surveys (with howLikelyToRecommend) */
  numberOfPostRideSurveys: z.number(),
  /** Number of history records with a check-out date */
  numberOfCheckOuts: z.number(),
  /** Any check-out up to a day is counted as one day, but a two day rental is two days, and so on. */
  rentalDays: z.number(),
  /** Number of days that this product line's vehicles were 'ActiveAtOperator' */
  activeAtOperatorDays: z.number(),
  /** (# of rentals days / (sum of each fleet vehicle's active-at-operator days in period)) */
  fleetUtilization: z.number()
})
export type StatisticsDto = z.infer<typeof StatisticsDto>

const GraphData = z
  .object({
    xValue: z.number(),
    yValue: z.number()
  })
  .array()
export type GraphData = z.infer<typeof GraphData>
